import { Difficulty } from "./Difficulty";
import { AuthState, isLoggedIn } from "util/useAuth/types";
import { MixPuzzle } from "./mixpuzzles/types";
import { getGameDescription } from "./helpers";
import { Game } from "./types/Game";

interface MixPuzzlePointProps {
  mixPuzzle: MixPuzzle;
  difficulty: Difficulty;
  auth: AuthState;
  correct: boolean;
}

export function getMixPuzzlePoints({
  mixPuzzle,
  auth,
  difficulty,
  correct,
}: MixPuzzlePointProps): number {
  if (!isLoggedIn(auth)) {
    return 0;
  }

  if (!correct) {
    return 0;
  }

  const mixPuzzleDescription = getGameDescription(Game.mixPuzzle);
  const points = mixPuzzleDescription.points[difficulty];
  const history = auth.user.mix_puzzle_history[mixPuzzle.id]?.[difficulty];

  if (!history) {
    return points;
  }

  if (!history.correct) {
    return points;
  }

  return mixPuzzleDescription.pointsWhenCompleted[difficulty];
}

interface GamePointProps {
  difficulty: Difficulty;
  auth: AuthState;
  correct: boolean;
  game: Game;
}

export function getGamePoints({
  auth,
  correct,
  difficulty,
  game,
}: GamePointProps): number {
  if (!isLoggedIn(auth)) {
    return 0;
  }

  if (!correct) {
    return 0;
  }

  const description = getGameDescription(game);

  return description.points[difficulty];
}
